import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GL_APPROVAL_LIMIT } from "./apiRoutes";

interface UseGetGlApprovalLimitByBudgetIdProps {
  budgetId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getGlApprovalLimitByBudgetId = async (budgetId: string) =>
  await axiosAuth.get(`${GL_APPROVAL_LIMIT}/by-budget/${budgetId}`);

const useGetGlApprovalLimitByBudgetId = ({
  queryParams,
  budgetId,
}: UseGetGlApprovalLimitByBudgetIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["gl-approval-limit-budget-id", budgetId],
    queryFn: () => getGlApprovalLimitByBudgetId(budgetId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!budgetId || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetGlApprovalLimitByBudgetId;
